"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iso2CountryOverrideMap = exports.EU_COUNTRY_CODE = exports.getCurrencyExchangeRateByLocale = exports.getUserPreferredLocale = exports.defaultCurrencyRate = exports.defaultCurrencyCode = exports.defaultLocale = exports.defaultLocaleCountryCode = void 0;
// import { LocaleCurrency } from '../types/Shared/Locale'
const constants_1 = require("./cookies/constants");
// Used for Locale Preferences both BE & FE
exports.defaultLocaleCountryCode = 'US';
exports.defaultLocale = 'en-US'; // en-US
exports.defaultCurrencyCode = 'USD';
exports.defaultCurrencyRate = {
    countryCode: 'US',
    currencyCode: exports.defaultCurrencyCode,
    displayName: 'United States',
    exchangeRate: 1,
    locale: 'en-US', // Can be lowerCase, but docs show en-CA
};
const getUserPreferredLocale = (req) => {
    if (req && req.cookies) {
        return req.cookies[constants_1.PREFERRED_LOCALE_COOKIE] || exports.defaultLocale;
    }
    return exports.defaultLocale;
};
exports.getUserPreferredLocale = getUserPreferredLocale;
// Preferred Locale Cookie
const getCurrencyExchangeRateByLocale = (data, locale) => {
    if (data[locale]) {
        return data[locale];
    }
    return exports.defaultCurrencyRate;
};
exports.getCurrencyExchangeRateByLocale = getCurrencyExchangeRateByLocale;
// map incoming akamai iso2 countries to a different value e.g. unify all
// countries using the euro
//
// This map is here because we only have one item for euros in the currency
// selector dropdown in the site UI. This allows us to map incoming akamai
// country headers for countries that are in the EU to the euros selection in
// that dropdown.
// technically the EU isn't a country but we treat it that way for currency
// conversion purposes.
exports.EU_COUNTRY_CODE = 'EU';
const europeanUnionCountries = {
    AT: exports.EU_COUNTRY_CODE,
    BE: exports.EU_COUNTRY_CODE,
    BG: exports.EU_COUNTRY_CODE,
    HR: exports.EU_COUNTRY_CODE,
    CY: exports.EU_COUNTRY_CODE,
    CZ: exports.EU_COUNTRY_CODE,
    DK: exports.EU_COUNTRY_CODE,
    EE: exports.EU_COUNTRY_CODE,
    FI: exports.EU_COUNTRY_CODE,
    FR: exports.EU_COUNTRY_CODE,
    GR: exports.EU_COUNTRY_CODE,
    DE: exports.EU_COUNTRY_CODE,
    HU: exports.EU_COUNTRY_CODE,
    IE: exports.EU_COUNTRY_CODE,
    IT: exports.EU_COUNTRY_CODE,
    LV: exports.EU_COUNTRY_CODE,
    LT: exports.EU_COUNTRY_CODE,
    LU: exports.EU_COUNTRY_CODE,
    MT: exports.EU_COUNTRY_CODE,
    NL: exports.EU_COUNTRY_CODE,
    PL: exports.EU_COUNTRY_CODE,
    PT: exports.EU_COUNTRY_CODE,
    RO: exports.EU_COUNTRY_CODE,
    SK: exports.EU_COUNTRY_CODE,
    SI: exports.EU_COUNTRY_CODE,
    ES: exports.EU_COUNTRY_CODE,
    SE: exports.EU_COUNTRY_CODE,
};
exports.iso2CountryOverrideMap = Object.assign({}, europeanUnionCountries);
